module.exports = __webpack_public_path__ + "static/media/diveBag.c0dadc58.svg";